/**
 * Smart Filter & Search uses product tags for several collection filters.
 * Shopify does not translate product tags, so this only localizes their
 * storefront labels on English pages. The underlying tag values are untouched.
 */
(() => {
  const translations = {
    Catégorie: 'Category',
    'Collection parfumée': 'Fragrance Collection',
    Préoccupation: 'Skin Concern',
    'Note Olfactive': 'Fragrance Notes',
    Senteur: 'Scent',
    Prix: 'Price',
    'Crème active': 'Active Cream',
    'Crème hydratante': 'Moisturizing Cream',
    'Crème sûr-mesure': 'Custom-made Cream',
    'Gel moussant': 'Foaming Scented Gel',
    'Gommage corps': 'Scented Body Scrub',
    'Huile corps': 'Scented Body Oil',
    'Lait corps': 'Scented Body Milk',
    'Nettoyant visage': 'Facial Cleanser',
    Parfum: 'Perfume',
    'Sérum actif visage': 'Active Facial Serum',
    'Anti-tâche': 'Anti-dark Spot',
    'Anti-âge': 'Anti-aging',
    Apaisant: 'Soothing',
    Assouplissant: 'Softening',
    Exfoliant: 'Exfoliating',
    Hydratant: 'Moisturizing',
    Lissant: 'Smoothing',
    Nettoyant: 'Cleansing',
    Nourissant: 'Nourishing',
    Parfumant: 'Fragrancing',
    Sublimateur: 'Enhancing',
    Éclat: 'Radiance',
    Ambrée: 'Amber',
    Boisée: 'Woody',
    Florale: 'Floral',
    Gourmand: 'Gourmand',
    Hespéridée: 'Citrus',
    Miellée: 'Honeyed',
    Musquée: 'Musky',
    Oud: 'Oud',
    Rose: 'Rose',
    'Thé Vert': 'Green Tea',
    Vanillée: 'Vanilla',
    Épicée: 'Spicy',
    'Fleur Blanche': 'White Flower',
    Floral: 'Floral',
    'Floral vanillé': 'Vanilla Floral',
    Lagon: 'Lagoon',
    Neutre: 'Neutral',
    Santal: 'Sandalwood',
    'Peau féminine': "Women's Skin",
    'Peau grasse': 'Oily Skin',
    'Peau masculine': "Men's Skin",
    'Peau mixte': 'Combination Skin',
    'Peau sèche': 'Dry Skin',
  };

  const translateElement = (element) => {
    const sourceText = element.dataset.relianceGloboSource || element.textContent.trim();
    const translatedText = translations[sourceText];

    if (!translatedText) return;

    element.dataset.relianceGloboSource = sourceText;
    if (element.textContent === translatedText) return;

    element.textContent = translatedText;

    const option = element.closest('a');
    if (option) option.setAttribute('title', translatedText);
  };

  const translateFilters = () => {
    document
      .querySelectorAll('#gf-tree .gf-block-title .h3 > span:first-child, #gf-tree .gf-label, #gf-tree .gf-option-value, #gf-tree .hidden-xs')
      .forEach(translateElement);
  };

  const watchFilterTree = () => {
    const filterTree = document.querySelector('#gf-tree');
    if (!filterTree) return false;

    new MutationObserver(translateFilters).observe(filterTree, {
      childList: true,
      subtree: true,
    });

    translateFilters();
    return true;
  };

  document.addEventListener('globoFilterRenderCompleted', translateFilters);

  document.addEventListener('DOMContentLoaded', () => {
    if (watchFilterTree()) return;

    const pageObserver = new MutationObserver(() => {
      if (watchFilterTree()) pageObserver.disconnect();
    });

    pageObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

